import * as Sentry from '@sentry/react'
import './util/sentry'

import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router'
import { Toaster } from 'sonner'

import ErrorPage from '@/components/error-page'
import { store } from '@/store'

import App from './App.tsx'
import './index.css'

const queryParams = new URLSearchParams(window.location.search)
const isStandalone = queryParams.get('desktop') === 'standalone'

window.isWebex = queryParams.get('desktop') === 'webex'
window.isZoom = window.navigator.userAgent.includes('ZoomApps')

const isDesktop = window.isWebex || window.isZoom
window.isStandalone = !isDesktop || isStandalone

createRoot(document.getElementById('root')!).render(
  <Sentry.ErrorBoundary fallback={<ErrorPage />}>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
    <Toaster richColors />
  </Sentry.ErrorBoundary>
)
